const messages = {
  name: 'Test |||| Tests',
  sections: {
    accountApplication: 'Account & application',
    message: 'Message',
    attachments: 'Attachments',
    recipients: 'Recipients',
    scheduling: 'Scheduling',
    delivery: 'Delivery options',
    notification: 'Notification',
    customData: 'Custom data',
    actions: 'Actions',
  },

  fields: {
    account: 'Account',
    application: 'Application',
    recipientType: 'Recipient Type',
    address: 'Address',
    number: 'Number',
    chatId: 'Chat ID',
    title: 'Title',
    type: 'Type',
    message: 'Message',
    icon: 'Icon',
    badge: 'Badge',
    tag: 'Tag',
    requireInteraction: 'Require Interaction',
    priority: 'Priority',
    action: 'Action',
    dataKey: 'Key',
    dataValue: 'Value',
    groupId: 'Group ID',
    messageType: 'Message Type',
    template: 'Template',
    language: 'Language',
    variableKey: 'Key',
    variableValue: 'Value',
    subject: 'Subject',
    content: 'Content',
    uploadAttachments: 'Upload Attachments',
    messagePriority: 'Message Priority',
    scheduleType: 'Schedule Type',
    scheduleDate: 'Schedule Date',
    scheduleTime: 'Schedule Time',
    intervalValue: 'Interval Value',
    intervalUnit: 'Interval Unit',
    expirationDate: 'Expiration Date',
    expirationTime: 'Expiration Time',
    timezone: 'Timezone',
    webhookUrl: 'Web Hook',
    whatsappMetaTemplate: 'WhatsApp Template (Meta)',
    whatsappTemplateSource: 'Template source',
    whatsappMetaTemplateHintNoAccount: 'Pick an account to load templates.',
    whatsappMetaTemplateHintEmpty: 'No templates found for this account.',
    headerMediaTitle: 'Template Header Media',
    headerMediaSourceUrl: 'Public URL',
    headerMediaSourceUpload: 'Upload File',
    headerMediaUrl: 'Media URL',
    headerMediaFilename: 'Filename (shown to recipient)',
    headerMediaFilenameHint: 'Sent as the document name to the recipient.',
    headerMediaDropzone: 'Click to choose a file',
    headerMediaDropzoneHint: 'Will upload to Meta on submit. Max %{max}.',
    headerMediaReady: 'ready to upload on submit',
    customMediaTitle: 'Media (optional)',
    customMediaType: 'Media Type',
    customMediaTypeHint: 'Leave empty to send a plain text message.',
    customMediaCaptionHint: 'Content below will be sent as the media caption.',
    customMediaAudioHint: 'Audio messages do not support captions — Content will be ignored.',
  },
  teamChat: {
    title: 'Team Chat Test Form',
    destination: 'Destination',
    target: 'Platform',
    targetHelp: 'Slack format also works for Mattermost / Rocket.Chat',
    targetRequired: 'Platform is required',
    webhookUrlField: 'Incoming webhook URL',
    webhookUrlRequired: 'Webhook URL is required',
    webhookUrlHttps: 'Must be an https:// URL',
    titleField: 'Title',
    severity: 'Severity',
    severityNone: 'None',
    textField: 'Text',
    textRequired: 'Text is required',
  },
  viber: { title: 'Viber Test Form' },
  line: { title: 'LINE Test Form' },
  botChat: {
    userId: 'User ID',
    userIdRequired: 'User ID is required',
    textField: 'Text',
    textRequired: 'Text is required',
    viberUserIdHelp: 'Viber user id of someone who opted in to the bot',
    lineUserIdHelp: 'LINE user id (U…) of someone who added the official account',
  },
  inbox: {
    title: 'Inbox Test Form',
    userIdHelp: "The tenant's own user identifier (any string)",
    linkField: 'Link (optional)',
    viewSection: 'Inbox of the first user',
    viewButton: 'View inbox',
    markAllRead: 'Mark all read',
    unread: '%{smart_count} unread',
  },
  webhook: {
    title: 'Webhook Test Form',
    urlField: 'Endpoint URL',
    eventField: 'Event',
    payloadSection: 'Payload',
    payloadField: 'JSON payload',
    payloadHelp: 'Delivered as-is as the POST body',
    payloadRequired: 'Payload is required',
    payloadInvalid: 'Payload is not valid JSON',
    secretField: 'Signing secret (optional)',
    secretHelp: 'If set, deliveries carry X-Notify-Signature (HMAC-SHA256)',
  },
  submenu: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WHATSAPP',
    telegram: 'Telegram',
    webPush: 'Web Push',
    appPush: 'App Push',
    teamChat: 'Team chat',
    viber: 'Viber',
    line: 'LINE',
    inbox: 'Inbox',
    webhook: 'Webhook',
  },
  choices: {
    recipientType: {
      INDIVIDUAL: 'INDIVIDUAL',
      GROUP: 'GROUP',
    },
    messageType: {
      TEMPLATE: 'TEMPLATE',
      CUSTOM: 'CUSTOM',
    },
    messagePriority: {
      CRITICAL: 'CRITICAL',
      STANDARD: 'STANDARD',
    },
    scheduleType: {
      NONE: 'NONE',
      ONCE: 'ONCE',
      RECURRING: 'RECURRING',
    },
    intervalUnit: {
      MINUTE: 'MINUTE',
      HOUR: 'HOUR',
      DAY: 'DAY',
      WEEK: 'WEEK',
      MONTH: 'MONTH',
      YEAR: 'YEAR',
    },
    headerMediaType: {
      IMAGE: 'IMAGE',
      DOCUMENT: 'DOCUMENT',
      VIDEO: 'VIDEO',
      AUDIO: 'AUDIO',
    },
    customMediaType: {
      NONE: 'None',
    },
  },
  email: { title: 'Email Test Form' },
  sms: { title: 'SMS Test Form' },
  whatsapp: { title: 'Whatsapp Test Form' },
  telegram: { title: 'Telegram Test Form' },
  webPush: { title: 'Web Push Test Form' },
  appPush: { title: 'App Push Test Form' },
  actions: {
    addAddresses: 'Add Addresses',
    addNumbers: 'Add Numbers',
    addChatIds: 'Add Chat ID',
    addVariable: 'Add Variable',
    addData: 'Add Data',
    addActions: 'Add Actions',
    addAttachment: '+ Add Attachment',
    headerMediaChooseFile: 'Choose file',
    cancel: 'Cancel',
    submit: 'Submit',
    sendTest: 'Send test',
    addAttachmentOrImage: 'Add attachment or inline image',
  },
  attachments: {
    chooseFile: 'Choose file',
    embedInline: 'Embed inline in email body (CID)',
    contentId: 'Content ID',
    contentIdHelper: 'Reference in HTML as <img src="cid:LOGO"/>',
    nonImageInlineWarning:
      'Inline attachments are usually images. Non-image MIME types may not display correctly.',
    errorUnsupportedType:
      'Only PDF, image, or plain-text files are supported.',
    noAttachments: 'No attachments. Click "+ Add Attachment" to add one.',
    insertImage: {
      title: 'Insert image',
      fileLabel: 'Image file',
      fileHelper: 'PNG / JPG / GIF up to 5MB',
      width: 'Width (px)',
      height: 'Height (px)',
      errorFileRequired: 'Please select an image file',
      errorNotImage: 'File must be an image',
      errorTooLarge: 'Image must be 5MB or smaller',
      insertButton: 'Insert',
    },
    attachFile: {
      title: 'Attach file',
      fileLabel: 'File',
      fileHelper: 'PDF, image, or plain-text file up to 5MB',
      attachButton: 'Attach',
    },
    preview: {
      heading: '%{smart_count} attachment |||| %{smart_count} attachments',
    },
  },
  editor: {
    bold: 'Bold',
    italic: 'Italic',
    bulletList: 'Bullet list',
    orderedList: 'Numbered list',
    insertImage: 'Insert image',
    attachFile: 'Attach file',
    undo: 'Undo',
    redo: 'Redo',
  },
  validation: {
    accountRequired: 'Account is required',
    applicationRequired: 'Application is required',
    recipientTypeRequired: 'Recipient Type is required',
    groupRequired: 'Group is required',
    numberRequired: 'Number is required',
    chatIdRequired: 'Chat ID is required',
    addressRequired: 'Address is required',
    messageTypeRequired: 'Message Type is required',
    templateRequired: 'Template is required',
    contentRequired: 'Content is required',
    messagePriorityRequired: 'Message Priority is required',
    typeRequired: 'Type is required',
    titleRequired: 'Title is required',
    messageRequired: 'Message is required',
    iconRequired: 'Icon is required',
    badgeRequired: 'Badge is required',
    tagRequired: 'Tag is required',
    priorityRequired: 'Priority is required',
    contentIdRequired: 'Content ID is required for inline attachments',
    contentIdInvalidChars:
      'Content ID may only contain letters, digits, underscores, hyphens and dots',
    contentIdDuplicate: 'Content ID must be unique across attachments',
    headerMediaUrlRequired: 'Media URL is required',
    headerMediaUrlInvalid: 'Enter a valid http(s) URL',
    headerMediaTooLarge: 'File exceeds the %{max} limit',
    headerMediaReadFailed: 'Failed to read file',
    headerMediaFilenameRequired: 'Filename is required for documents',
  },
  notifications: {
    emailSent: 'Email sent successfully',
    smsSent: 'SMS sent successfully',
    whatsappSent: 'Whatsapp message sent successfully',
    telegramSent: 'Telegram sent successfully',
    teamChatSent: 'Team-chat message posted successfully',
    viberSent: 'Viber sent successfully',
    lineSent: 'LINE sent successfully',
    inboxSent: 'Inbox message stored',
    webhookSent: 'Webhook delivered successfully',
    webPushSent: 'Web Notification sent successfully',
    appPushSent: 'App Push Notification sent successfully',
    emailSendFailed: 'Failed to send email',
    smsSendFailed: 'Failed to send SMS',
    whatsappSendFailed: 'Failed to send Whatsapp message',
    telegramSendFailed: 'Failed to send Telegram message',
    teamChatSendFailed: 'Failed to post team-chat message',
    viberSendFailed: 'Failed to send Viber message',
    lineSendFailed: 'Failed to send LINE message',
    inboxSendFailed: 'Failed to store inbox message',
    webhookSendFailed: 'Failed to deliver webhook',
    inboxLoadFailed: 'Failed to load inbox',
    webPushSendFailed: 'Failed to send Web Notification',
    appPushSendFailed: 'Failed to send App Push Notification',
    loadAccountsFailed: 'Failed to load accounts',
    attachmentReadFailed: 'Failed to read attachment',
  },
};

export default messages;
